import IconBase from "../IconBase";

const PhoneIcon = (props) => {
  return (
    <IconBase {...props}>
      <path
        d="M19.23 15.26L16.69 14.97C16.3913 14.9349 16.0886 14.968 15.8045 15.0667C15.5205 15.1654 15.2625 15.3273 15.05 15.54L13.21 17.38C10.3714 15.9359 8.06404 13.6286 6.61998 10.79L8.46998 8.94001C8.89998 8.51001 9.10998 7.91001 9.03998 7.30001L8.74998 4.78001C8.6935 4.2921 8.45945 3.84204 8.09244 3.51561C7.72544 3.18918 7.25115 3.00921 6.75998 3.01001H5.02998C3.89998 3.01001 2.95998 3.95001 3.02998 5.08001C3.55998 13.62 10.39 20.44 18.92 20.97C20.05 21.04 20.99 20.1 20.99 18.97V17.24C21 16.23 20.24 15.38 19.23 15.26Z"
        fill="currentColor"
      />
    </IconBase>
  );
};

export default PhoneIcon;
